module.exports = __webpack_public_path__ + "img/02叶会华.11f66173.jpg";